export default __webpack_public_path__ + "static/media/cloud-infrastructure-tab.f9ed9b1a.png";